import { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import {
  PatchScheduleExpectationCycleData,
  ScheduleExpectationCycle
} from '@/types/scheduleExpectation';
import ajax from '@/utils/ajax';

export const scheduleExpectationCycleRepository = {
  BASE_PATH: '/api/dugout/schedule_expectation_cycles/',

  async get({ host, id }: { host: string; id: string }): Promise<ScheduleExpectationCycle> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}${id}/`
    });

    return response.data;
  },

  async patch({
    host,
    id,
    data
  }: {
    host: string;
    id: string;
    data: PatchScheduleExpectationCycleData;
  }): Promise<ScheduleExpectationCycle> {
    const response = await ajax.patch<
      PatchScheduleExpectationCycleData,
      AxiosResponse<ScheduleExpectationCycle>
    >({
      url: `${host}${this.BASE_PATH}${id}/`,
      data
    });

    return response.data;
  }
};

const ScheduleExpectationCycleRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async get({ id }: { id: string }) {
      return scheduleExpectationCycleRepository.get({ host, id });
    },

    async patch({ id, data }: { id: string; data: PatchScheduleExpectationCycleData }) {
      return scheduleExpectationCycleRepository.patch({ host, id, data });
    }
  };
};

export default ScheduleExpectationCycleRepository;
